module.exports = __webpack_public_path__ + "static/media/Crowding of teeth on both jaws6.f22f5040.png";